const modals =  {
  modalContainers: document.getElementsByClassName('modal-container'),
  modalCloseElements: document.getElementsByClassName('close-modal'),
  modalOpenElements: document.getElementsByClassName('open-modal'),
  modalTimers: [],

  init: function () {
    const _self = this;

    if (this.modalContainers.length) {
      for (const modal of this.modalContainers) {
        if ('#' + modal.dataset.modalId === window.location.hash) {
          this.openModal(modal.dataset.modalId);
        }

        if (modal.dataset.timer > 0) {
          this.setModalTimer(this.setModalTimer(modal.dataset.modalId, modal.dataset.timer));
        }
      }

      for (const modalOpenElement of this.modalOpenElements) {
        modalOpenElement.addEventListener('click', function (e) {
          e.preventDefault();
          _self.closeAllModals();
          _self.openModal(this.dataset.target);
        });
      }

      for (const modalCloseElement of this.modalCloseElements) {
        modalCloseElement.addEventListener('click', function (e) {
          _self.closeModal(this.dataset.target);
        });
      }

      window.addEventListener('popstate', () => {
        _self.closeAllModals()
      });

      return true;
    } else return false;
  },

  openModal: function (modalId) {
    for (const modalContainer of this.modalContainers) {
      if (modalContainer.dataset.modalId === modalId) {
        history.pushState({}, '', '#' + modalId);
        modalContainer.classList.add('show');
        this.storeScrollPosition(); // iphone help...
        document.body.classList.add('no-scroll', 'elevated-container-open');
        break;
      }
    }
  },

  closeModal: function (modalId) {
    for (const modalContainer of this.modalContainers) {
      if (modalContainer.dataset.modalId === modalId) {
        history.pushState({}, '', window.location.href.split('#')[0]);
        modalContainer.classList.remove('show');
        document.body.classList.remove('no-scroll', 'elevated-container-open');
        this.restoreScrollPosition(); // iphone help...
        break;
      }
    }
  },

  closeAllModals: function () {
    for (const modalContainer of this.modalContainers) {
      if (modalContainer.classList.contains('show')) {
        modalContainer.classList.remove('show');
      }
    }
  },

  storeScrollPosition: function(){
    document.body.setAttribute('data-scroll-y-position',window.pageYOffset);
  },

  restoreScrollPosition: function(){
    const pos = document.body.dataset.scrollYPosition;
    if( typeof pos !== 'undefined' ) {
      window.scrollTo(0, pos);
      document.body.removeAttribute('data-scroll-y-position');
    }
  },

  setModalTimer: function (modalId, time) {
    const _self = this;
    this.modalTimers.push(window.setTimeout(function () {
      _self.closeModal(modalId)
    }, time * 1000));
  }
};

export default modals;
